// extracted by mini-css-extract-plugin
export default {"root":"IconReport_root__XY6bv"};